import Client, { LeadStage } from '@spike/client-model';

export interface LeadStageStep {
    stage: LeadStage;
    label: string;
    reached: boolean;
}

export const LEAD_STAGE_ORDER: ReadonlyArray<LeadStage> = [
    LeadStage.New,
    LeadStage.Contacted,
    LeadStage.Booked,
    LeadStage.Won,
    LeadStage.Lost
];

const STAGE_LABELS: Record<LeadStage, string> = {
    [LeadStage.New]: 'New',
    [LeadStage.Contacted]: 'Contacted',
    [LeadStage.Booked]: 'Booked',
    [LeadStage.Won]: 'Won',
    [LeadStage.Lost]: 'Lost'
};

/**
 * There is no stage-transition history, so reached-state is derived from the lead's
 * current fields. Each stage is evaluated independently rather than as a prefix of the
 * progression — a lead that booked and later moved to Won or Lost still shows Booked.
 */
const isStageReached = (lead: Client, stage: LeadStage): boolean => {
    switch (stage) {
        case LeadStage.New:
            return true;
        case LeadStage.Contacted:
            return lead.lastContactedAt != null;
        case LeadStage.Booked:
            return lead.firstBookedDate != null || lead.leadStage === LeadStage.Booked;
        case LeadStage.Won:
            return lead.leadStage === LeadStage.Won || lead.clientSince != null;
        case LeadStage.Lost:
            return lead.leadStage === LeadStage.Lost;
    }
};

export const buildLeadStageSteps = (lead: Client): Array<LeadStageStep> =>
    LEAD_STAGE_ORDER.map(stage => ({
        stage,
        label: STAGE_LABELS[stage],
        reached: isStageReached(lead, stage)
    }));
